import { all, fork, takeEvery } from 'redux-saga/effects';
import { LOAD_SERVICES, UPDATE_SERVICE, DELETE_SERVICE } from 'constants/ActionTypes';
import { deleteEntity, loadEntities, updateEntity } from 'helpers/utilHelpers';

export function* loadServices() {
  yield takeEvery(LOAD_SERVICES, loadEntities);
}

function* updateService() {
  yield takeEvery(UPDATE_SERVICE, updateEntity);
}

function* deleteService() {
  yield takeEvery(DELETE_SERVICE, deleteEntity);
}

export default function* rootSaga() {
  yield all([fork(deleteService), fork(updateService), fork(loadServices)]);
}
